<template>
  <div id="app">
    <div class="home">
      {{home}}
    </div>
    <div class="content" v-if="isRoot">
      <nav>
        <list :home="home" :projects="projects"></list>
      </nav>
      <div class="infobox">
        <div class="about" v-html="misc.about">
        </div>
        <div class="pages" v-for="project in invisibleProjects">
          <router-link :to="project.slug">
            {{project.title}}
          </router-link>
        </div>
      </div>
    </div>
    <footer>
      <ul>
        <li v-for="c in misc.columns">
          <div class="inner" v-html="c"></div>
        </li>
      </ul>
    </footer>

    <router-view name="page-flipper" :hidden="hidePageFlipper" :is-animating="false"></router-view>

    <transition :name="direction" v-on:before-enter="beforeEnter" v-on:after-leave="afterLeave">
      <router-view :key="$route.params.slug" :project="currentProject" :is-animating="isAnimating"></router-view>
    </transition>

    <router-view v-on:home-reset="setHome" name="cross"></router-view>
  </div>
</template>
<script>
  import List from './components/List.vue'
  import Project from './components/Project.vue'
  import PageFlipper from './components/PageFlipper.vue'

  export default {
    data () {
      return {
        name: 'App',
        loading: false,
        projects: [],
        home: '',
        misc: {},
        error: null,
        direction:'initial',
        isAnimating: false,
        isRoot: true
      }
    },
    created () {
      this.fetchData();
      this.$on('next',function() {
        this.next();
      })
      this.$on('reset',function() {
        this.reset();
      })
      this.$on('prev',function() {
        this.prev();
      })
    },
    methods: {
      beforeEnter () {
        if(this.direction!='initial') {
          this.isAnimating = true;
        }

      },
      reset () {
        this.direction = 'initial';
      },
      afterLeave () {
        this.direction = 'initial';
        this.isAnimating = false;
      },
      setHome () {
        // this.direction = 'initial';
        // console.log('s')
        this.$router.push('/');
      },
      fetchData () {
        this.error = null;
        this.loading = true;
        let slug = this.$route.params.slug
        this.$http.get('projects/').then((response) => {
          // console.log(response.data);
          let data = response.data;
          this.projects = data.projects;
          this.misc = data.misc;
          this.home = data.home;
          this.loading = false;
        }, (response) => {
          this.error = response.toString();
          this.loading = false;
        });
      },
      next: function() {
        this.direction = 'right';
        let tot = this.currentProject.pages.length;

        let cur = parseInt(this.$route.params.page,10);
        if(cur>=tot) {
          this.$router.push({
            name:'page',
            params: {
              slug: this.nextProject.slug,
              page: '1'
            }
          });
        } else {
          this.$router.push({
            name:'page',
            params: {
              slug: this.currentProject.slug,
              page: cur+1
            }
          });
        }
      },
      prev: function() {
        this.direction = 'left';
        let tot = this.currentProject.pages.length;
        let cur = parseInt(this.$route.params.page,10);
        if(cur<=1) {
          this.$router.push({
            name:'page',
            params: {
              slug: this.previousProject.slug,
              page: this.previousProject.pages.length
            }
          });
        } else {
          this.$router.push({
            name:'page',
            params: {
              slug: this.currentProject.slug,
              page: cur-1
            }
          });
        }
      }
    },
    components: {
      'list': List,
      'project': Project,
      'PageFlipper': PageFlipper
    },
    computed: {
      visibleProjects () {
        return this.projects.filter(n => n.hidden!==1);
      },
      invisibleProjects () {
        return this.projects.filter(n => n.hidden===1);
      },
      hidePageFlipper () {
        if(this.currentProject) {
          if(this.currentProject.hidden===1) {
            return true;
          }
        }
        return false;
      },
      currentProject () {
        let projectArray = this.projects.filter( el => {
          return el.slug==this.$route.params.slug;
        });
        return projectArray[0];
      },
      nextProject () {
        let l = this.visibleProjects.indexOf(this.currentProject);
        if(l>=this.visibleProjects.length-1) {
          return this.visibleProjects[0];
        }
        return this.visibleProjects[l+1];
      },
      previousProject () {
        let l = this.visibleProjects.indexOf(this.currentProject);
        if(l==0) {
          return this.visibleProjects[this.visibleProjects.length-1];
        }
        return this.visibleProjects[l-1];
      }

    },
    watch: {
      '$route': function(to,from) {
        this.isRoot = to.path=='/';
        document.body.style.zoom = 1.0;
      }
    }
  }
</script>
<style lang="scss">
  @import "global.scss";

  #app {
    font-family:TriviaHumanistMedium,serif;
    em {
      font-family:'TriviaHumanistMedium-italic';
    }

    a {
      text-decoration: none;
      color:#000;
      &:hover {
        color:#ff0;
      }
    }
    nav {
      padding-bottom:0rem;
    }
    img {
      vertical-align:bottom;
    }
  }
  div {
    // border:1px solid #f00;
  }
  body {
    font-size:1.3rem;
    line-height:1.2;
    user-select: none;
    overflow-y: scroll;
    .home {
      padding:1rem;
    }
    .content {
      overflow: hidden;
      .infobox {
        padding:1rem;

        max-width: 35rem;
        .pages {
          // margin-left: 1rem;
        }
        p {
          margin-bottom: 1rem;
        }

        @media #{$medium-up} {
          width: 50%;
          float:left;
        }
      }
      @media #{$medium-up} {
        min-height:calc(100vh - 12rem);
      }
    }
    footer {
      li {
        padding: 1rem;
        .inner {
          max-width: 22rem;
          p+p {
            // margin-left: 1rem;
          }
        }
      }
      @media #{$medium-up} {
        ul {
          // position: absolute;
          // bottom: 0;
          // left:0;
          // width: 100%;

          overflow: hidden;
          li {
            float:left;
            width: 33.333%;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue